/* eslint-disable */
/* eslint-disable eslint-comments/no-unused-disable */
/* 
* The file is automatically generated by Serenity UI.
* 
* ⚠️ WARNING: Any manual changes may be overwritten during the next upgrade
* 
* Found an issue? Submit a task to the ClickUp board:
* https://app.clickup.com/1255586/v/l/6-901510012553-1?pr=90154030902
*/
import { type ForwardedRef, forwardRef } from 'react';
import { type IconProps, Icon } from '../../components/icon/icon.component';

const VerificationStrokeIcon = forwardRef((props: IconProps, ref: ForwardedRef<SVGSVGElement>) => {
  return (
    <Icon {...props} ref={ref}>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
          d="M9.33324 12L10.9332 13.6L14.1332 10.4M2.3999 10.6848C2.39991 15.4054 5.33025 19.6301 9.75167 21.2838L9.78375 21.2958C10.8691 21.7018 12.0647 21.7014 13.1498 21.2948L13.1758 21.285C17.6012 19.6266 20.5332 15.3965 20.5333 10.6706V6.69894C20.5333 5.76574 19.9267 4.94085 19.0359 4.66262L12.1026 2.49704C11.6885 2.36769 11.2447 2.36769 10.8306 2.49704L3.89723 4.66256C3.00646 4.94077 2.3999 5.76567 2.3999 6.69888V10.6848Z"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </Icon>
  );
});

export { VerificationStrokeIcon };
